import BbsListItem from "./BbsListItem";

function BbsNoticeList({ posts, moduleName }) {
  if (!posts.length) return null;
  return (
    <div className="space-y-3">
      {posts.map((item) => (
        <BbsListItem
          key={`notice-${item.id}`}
          item={item}
          moduleName={moduleName}
          currentPage={1}
          selectedCategory={""}
          isNotice
        />
      ))}
    </div>
  );
}

export default BbsNoticeList;
